import { j as e } from '../../_virtual/jsx-runtime.js';
const t = () =>
  /* @__PURE__ */ e.jsx('div', {
    className:
      'bg-mobile-hero flex justify-center items-center bg-cover bg-center sm:bg-desktop-hero h-[290px] sm:h-[267px]',
    children: /* @__PURE__ */ e.jsxs('div', {
      className: 'bg-neutral-100 max-w-[700px] mx-5 p-5 tablet:p-8',
      children: [
        /* @__PURE__ */ e.jsx('h1', {
          className: 'text-heading-1 text-center mb-4',
          children: 'Under maintenance',
        }),
        /* @__PURE__ */ e.jsx('p', {
          children:
            'Our website is currently undergoing scheduled maintenance to enhance your experience. Please try again later.',
        }),
      ],
    }),
  });
export { t as Maintenance };
